// extracted by mini-css-extract-plugin
export default {"divider":"LicenseSection_divider--svK","license":"LicenseSection_license--Ttt"};